import { C } from '@angular/cdk/keycodes';
import {
    IQueryContext,
    IQueryContextDatasourceColumn,
} from 'src/app/services/query-context/models/IQueryContext';
import {
    DatasourceColumnId,
    ICompiledSQLTokens,
    IDatasourceSQLMap,
    mergeSqlTokensArray,
} from 'src/app/utils/datasource-sql-map/datasource';
import { DatePickerSqlTokensCompiler } from 'src/app/utils/datasource-sql-map/date-picker-sql-tokens-compiler';
import { multipleSelectComponentCompileSQLTokens } from 'src/app/utils/datasource-sql-map/utils';
import { GcpProjectId } from 'src/app/utils/gcp-project-id.model';
import { buildSplitGroupSQL, buildWhereSQL } from 'src/app/utils/query/sql';
import { sqlDatetimeLabel, sqlDatetimeTrunc } from 'src/app/utils/sql';

export class BiVizRealtimeCloudSaveGenericDatasource {
    static _sqlMap(tableId: string): IDatasourceSQLMap {
        return {
            dataset: 'bi_viz',
            tableId: tableId,
            columns: {
                // ACTIVITY_DATE: {
                //     columnId: 'ACTIVITY_DATE',
                //     columnSQL: 'time_hour',
                //     compileSQLTokens: (state) => {
                //         return DatePickerSqlTokensCompiler.compileTokens(
                //             'DATE(time_hour)',
                //             state
                //         );
                //     },
                // },
                ACTIVITY_DATETIME: {
                    columnId: 'ACTIVITY_DATETIME',
                    columnSQL: 'time_hour',
                    compileSQLTokens: (state) => {
                        return DatePickerSqlTokensCompiler.compileTokens(
                            'DATE(time_hour)',
                            state
                        );
                    },
                },
                ACTIVITY_HOUR: {
                    columnId: 'ACTIVITY_HOUR',
                    columnSQL: 'hour',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'hour',
                            state
                        );
                    },
                },
                ACTIVITY_WEEKDAY: {
                    columnId: 'ACTIVITY_WEEKDAY',
                    columnSQL: 'FORMAT_DATETIME("%A", time_hour)',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'FORMAT_DATETIME("%A", time_hour)',
                            state
                        );
                    },
                },
                ACTIVITY_APP_VERSION: {
                    columnId: 'ACTIVITY_APP_VERSION',
                    columnSQL: 'app_version',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'app_version',
                            state
                        );
                    },
                },
                FIREBASE_APP_STORE: {
                    columnId: 'FIREBASE_APP_STORE',
                    columnSQL: 'app_store',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'app_store',
                            state
                        );
                    },
                },
                FIREBASE_COUNTRY_EUROPEAN_UNION: {
                    columnId: 'FIREBASE_COUNTRY_EUROPEAN_UNION',
                    columnSQL: 'european_union',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'european_union',
                            state
                        );
                    },
                },
                FIREBASE_COUNTRY_TIER: {
                    columnId: 'FIREBASE_COUNTRY_TIER',
                    columnSQL: 'country_tier',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'country_tier',
                            state
                        );
                    },
                },
                FIREBASE_COUNTRY: {
                    columnId: 'FIREBASE_COUNTRY',
                    columnSQL: 'unified_country',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'unified_country',
                            state
                        );
                    },
                },
                FIREBASE_COUNTRY_US_REGION: {
                    columnId: 'FIREBASE_COUNTRY_US_REGION',
                    columnSQL: 'us_region',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'us_region',
                            state
                        );
                    },
                },
                EVENT_PROJECT_ID: {
                    columnId: 'EVENT_PROJECT_ID',
                    columnSQL: 'project_id',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'project_id',
                            state
                        );
                    },
                },
                SALES_INAPP_SOURCE: {
                    columnId: 'SALES_INAPP_SOURCE',
                    columnSQL: 'PurchaseComplete_Source',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'PurchaseComplete_Source',
                            state
                        );
                    },
                },
                // realtime_battery_save
                REALTIME_BATTERY_SAVE: {
                    columnId: 'REALTIME_BATTERY_SAVE',
                    columnSQL: 'battery_save',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'battery_save',
                            state
                        );
                    },
                },
                // realtime_is_anonymous
                REALTIME_IS_ANONYMOUS: {
                    columnId: 'REALTIME_IS_ANONYMOUS',
                    columnSQL: 'is_anonymous',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'is_anonymous',
                            state
                        );
                    },
                },
                // realtime_is_small
                REALTIME_IS_SMALL: {
                    columnId: 'REALTIME_IS_SMALL',
                    columnSQL: 'is_small',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'is_small',
                            state
                        );
                    },
                },
                // realtime_is_background
                REALTIME_IS_BACKGROUND: {
                    columnId: 'REALTIME_IS_BACKGROUND',
                    columnSQL: 'is_background',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'is_background',
                            state
                        );
                    },
                },
                // realtime_error
                REALTIME_ERROR: {
                    columnId: 'REALTIME_ERROR',
                    columnSQL: 'error',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'error',
                            state
                        );
                    },
                },
                // realtime_internal_error
                REALTIME_INTERNAL_ERROR: {
                    columnId: 'REALTIME_INTERNAL_ERROR',
                    columnSQL: 'internal_error',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'internal_error',
                            state
                        );
                    },
                },
                // realtime_is_success
                REALTIME_IS_SUCCESS: {
                    columnId: 'REALTIME_IS_SUCCESS',
                    columnSQL: 'is_success',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'is_success',
                            state
                        );
                    },
                },
                // realtime_failure_rate_definition
                REALTIME_FAILURE_RATE_DEFINITION: {
                    columnId: 'REALTIME_FAILURE_RATE_DEFINITION',
                    columnSQL: 'is_success',
                    compileSQLTokens: (state) => {
                        return multipleSelectComponentCompileSQLTokens(
                            'is_success',
                            state
                        );
                    },
                },
            },
        };
    }

    // compile sql statements specific for this datasource
    static _compileSQLStatements(
        sqlMap: IDatasourceSQLMap,
        supportedDatasourceColumns: IQueryContextDatasourceColumn[],
        queryContextSettings: IQueryContext['settings'],
        options: { gcpProjectId: GcpProjectId },
        customCompiledSqlTokens?: Partial<ICompiledSQLTokens>,
        nonCommonColumns?: DatasourceColumnId[]
    ) {
        // assume default datetimeAggregation is hour
        // const dateTrunc = sqlDatetimeTrunc(
        //     'DATETIME(time_hour)',
        //     queryContextSettings.datetimeAggregation ?? 'hour'
        // );
        const datetimeTrunc = (column?: string) => {
            column =
                column ??
                this._sqlMap('').columns?.ACTIVITY_DATETIME!.columnSQL;
            return queryContextSettings.datetimeAggregation
                ? sqlDatetimeTrunc(
                      column,
                      queryContextSettings.datetimeAggregation
                  )
                : column;
        };

        const datetimeLabel = (column?: string) => {
            column =
                column ??
                this._sqlMap('').columns?.ACTIVITY_DATETIME!.columnSQL;
            return queryContextSettings.datetimeAggregation
                ? sqlDatetimeLabel(
                      column,
                      queryContextSettings.datetimeAggregation
                  )
                : column;
        };

        // merge tokens into single deduplicated object of type ICompiledSQLTokens
        const sqlTokens: ICompiledSQLTokens = mergeSqlTokensArray(
            supportedDatasourceColumns.map((dsCol) => {
                return sqlMap.columns[dsCol.id]!.compileSQLTokens!(
                    dsCol.state,
                    options
                );
            })
        );

        // CUSTOM FILTER FOR THIS TABLE
        // sqlTokens.where.push(`validation_flag IS NULL`);

        // unnest app_version_activity if app_version is present in splits or filters
        // TODO to powinno być rozwiązane na poziomie datasource, gdzie compileSQL zwróci atrybut join, z treścią `, UNNEST...`

        const splitSelect: string = buildSplitGroupSQL(sqlTokens.split_group);
        const splitSelectFn = (alias: string, endComma: boolean) => {
            return buildSplitGroupSQL(sqlTokens.split_group, alias, endComma);
        };
        const splitGroup = splitSelect ? 'split_group' : '';
        const splitGroupBy = splitSelect ? 'split_group, ' : '';
        const where: string = buildWhereSQL([
            ...sqlTokens.where,
            ...(customCompiledSqlTokens?.where ?? []),
        ]);
        // const join: string = sqlTokens.join.join('\n');
        // const windowTotal = splitGroupBy ? 'PARTITION BY split_group' : '';
        const windowRunning = splitGroupBy
            ? 'PARTITION BY split_group ORDER BY day_no'
            : 'ORDER BY day_no';

        nonCommonColumns = nonCommonColumns ?? [
            'REALTIME_FAILURE_RATE_DEFINITION',
        ];

        const cohortSqlTokens: ICompiledSQLTokens = mergeSqlTokensArray(
            supportedDatasourceColumns
                .filter((dsCol) => nonCommonColumns!.indexOf(dsCol.id) === -1)
                .map((dsCol) => {
                    return sqlMap.columns[dsCol.id]!.compileSQLTokens!(
                        dsCol.state,
                        options
                    );
                })
        );

        const cohortSplitSelect: string = buildSplitGroupSQL(
            cohortSqlTokens.split_group,
            'cohort_split_group'
        );

        const cohortSplitGroupAlias = cohortSplitSelect
            ? 'cohort_split_group'
            : '';

        const cohortSplitGroupBy = cohortSplitSelect
            ? ', cohort_split_group'
            : '';

        const nonCommonColumnsSqlTokens: ICompiledSQLTokens =
            mergeSqlTokensArray(
                supportedDatasourceColumns
                    .filter((dsCol) => nonCommonColumns!.includes(dsCol.id))
                    .map((dsCol) => {
                        return sqlMap.columns[dsCol.id]!.compileSQLTokens!(
                            dsCol.state,
                            options
                        );
                    })
            );

        const DATASOURCE_SPECIFIC_SPLIT_GROUP = 'non_common_split_group';

        const datasourceSpecificSplitSelect = buildSplitGroupSQL(
            nonCommonColumnsSqlTokens.split_group,
            DATASOURCE_SPECIFIC_SPLIT_GROUP
        );
        const datasourceSpecificSplitGroupAlias = datasourceSpecificSplitSelect
            ? DATASOURCE_SPECIFIC_SPLIT_GROUP
            : '';
        // to samo ale z przecinkiem na koncu
        const datasourceSpecificSplitGroupBy = datasourceSpecificSplitSelect
            ? `${datasourceSpecificSplitGroupAlias}, `
            : '';

        /**
         * Constructs a SQL split group clause by concatenating the cohort and revenue split group aliases.
         *
         * This function first checks if both cohort and revenue split group aliases are present. If they are, it concatenates them with a comma separator and returns the result as 'split_group'.
         * If only one of them is present, it returns that one as 'split_group'.
         * If neither of them is present, it returns an empty string.
         *
         * @returns {string} - A SQL split group clause, or an empty string if neither cohort nor revenue split group alias is present.
         *
         * @example
         * // Assuming cohortSplitGroupAlias = "cohort_alias" and revenueSplitGroupAlias = "revenue_alias"
         * const splitGroupClause = splitSelectConcatCohortAdsFlow();
         * // Outputs: "CONCAT(cohort_alias, ', ', revenue_alias) AS split_group,"
         */
        const splitSelectConcatCohortAndDatasourceSpecificColumn = (() => {
            const areBothPresent =
                cohortSplitGroupBy != '' &&
                datasourceSpecificSplitGroupBy != '';

            if (areBothPresent) {
                return `CONCAT(${cohortSplitGroupAlias}, ', ', ${datasourceSpecificSplitGroupAlias} ) AS split_group,`;
            }
            // if any of them is present then return it
            if (
                datasourceSpecificSplitGroupBy != '' ||
                cohortSplitGroupBy != ''
            ) {
                // remove trailing comma
                return `${datasourceSpecificSplitGroupAlias}${cohortSplitGroupAlias} AS split_group,`;
            }
            return '';
        })();

        return {
            datetimeTrunc,
            datetimeLabel,
            splitSelect,
            splitSelectFn,
            splitGroup,
            splitGroupBy,
            cohortSplitSelect,
            cohortSplitGroupAlias,
            cohortSplitGroupBy,
            /**  `non common columns AS split_group` or empty string */
            splitSelectConcatCohortAndDatasourceSpecificColumn,
            /** `REVENUE_SPECIFIC_SPLITS AS revenue_split_group`  or empty string */
            datasourceSpecificSplitSelect,
            /** `revenue_split_group` or empty string */
            datasourceSpecificSplitGroupAlias,
            /** `revenue_split_group,` (NOTICE comma at the end) or empty string */
            datasourceSpecificSplitGroupBy,
            where,
            // windowTotal,
            windowRunning,
            // join,
        };
    }

    public static compileWhereSQLHoursUpToLatest(latest_hour: number) {
        return `hour <= ${latest_hour}`;
    }

    public static compileWhereSQLCurrentWeekday(weekday: string) {
        return `FORMAT_DATETIME("%A", time_hour) = '${weekday}'`;
    }

    public static getMetricQueryWithNullsBetweenDates(
        baseQuery: string,
        compiledSQLStatements: any,
        context: IQueryContext
    ) {
        const timestampOrDateArraySQL = ((context: IQueryContext) => {
            switch (context.settings.datetimeAggregation) {
                case 'hour':
                    return `GENERATE_TIMESTAMP_ARRAY(TIMESTAMP(MIN(date)), TIMESTAMP(MAX(date)), INTERVAL 1 HOUR) AS dates`;
                case 'day':
                    return `GENERATE_DATE_ARRAY(DATE(MIN(date)), DATE(MAX(date)), INTERVAL 1 DAY) AS dates`;
                case 'week':
                    return `GENERATE_DATE_ARRAY(DATE(MIN(date)), DATE(MAX(date)), INTERVAL 1 WEEK) AS dates`;
                case 'month':
                    return `GENERATE_DATE_ARRAY(DATE(MIN(date)), DATE(MAX(date)), INTERVAL 1 MONTH) AS dates`;
                default:
                    throw new Error(
                        `Unsupported datetimeAggregation: ${context.settings.datetimeAggregation}`
                    );
            }
        })(context);

        return `WITH base AS
        (
            ${baseQuery}
        )
        
        , dates AS
        (
          SELECT 
            ${compiledSQLStatements.splitGroupBy}DATETIME(date) AS date
          FROM
          (
            SELECT
              ${compiledSQLStatements.splitGroupBy}
              ${timestampOrDateArraySQL}
            FROM base
            ${compiledSQLStatements.splitGroupBy ? 'GROUP BY split_group' : ''}
          ), UNNEST(dates) date
        )
        
        SELECT *
        FROM base
        FULL JOIN dates
        USING(${compiledSQLStatements.splitGroupBy}date)
        ORDER BY ${compiledSQLStatements.splitGroupBy}date ASC
        `;
    }
}

// commits
export class BiVizRealtimeCloudSaveCommitsDatasource {
    static sqlMap: IDatasourceSQLMap =
        BiVizRealtimeCloudSaveGenericDatasource._sqlMap(
            'realtime_cloud_save_commits'
        );

    static compileSQLStatements(
        supportedDatasourceColumns: IQueryContextDatasourceColumn[],
        queryContextSettings: IQueryContext['settings'],
        options: { gcpProjectId: GcpProjectId },
        customCompiledSqlTokens?: Partial<ICompiledSQLTokens>
    ) {
        return BiVizRealtimeCloudSaveGenericDatasource._compileSQLStatements(
            this.sqlMap,
            supportedDatasourceColumns,
            queryContextSettings,
            options,
            customCompiledSqlTokens
        );
    }
}

// conflicts
export class BiVizRealtimeCloudSaveConflictsDatasource {
    static get sqlMap(): IDatasourceSQLMap {
        const _sqlMap = BiVizRealtimeCloudSaveGenericDatasource._sqlMap(
            'realtime_cloud_save_conflicts'
        );

        // remove unsupported columns
        delete _sqlMap.columns.REALTIME_BATTERY_SAVE;
        // delete _sqlMap.columns.REALTIME_ERROR;
        delete _sqlMap.columns.REALTIME_INTERNAL_ERROR;
        delete _sqlMap.columns.REALTIME_IS_ANONYMOUS;
        delete _sqlMap.columns.REALTIME_IS_BACKGROUND;
        delete _sqlMap.columns.REALTIME_IS_SMALL;
        // delete _sqlMap.columns.REALTIME_IS_SUCCESS;
        // delete _sqlMap.columns.REALTIME_FAILURE_RATE_DEFINITION;

        return _sqlMap;
    }

    static compileSQLStatements(
        supportedDatasourceColumns: IQueryContextDatasourceColumn[],
        queryContextSettings: IQueryContext['settings'],
        options: { gcpProjectId: GcpProjectId },
        customCompiledSqlTokens?: Partial<ICompiledSQLTokens>
    ) {
        return BiVizRealtimeCloudSaveGenericDatasource._compileSQLStatements(
            this.sqlMap,
            supportedDatasourceColumns,
            queryContextSettings,
            options,
            customCompiledSqlTokens
        );
    }
}

// downloads
export class BiVizRealtimeCloudSaveDownloadsDatasource {
    static get sqlMap(): IDatasourceSQLMap {
        const _sqlMap = BiVizRealtimeCloudSaveGenericDatasource._sqlMap(
            'realtime_cloud_save_downloads'
        );

        // remove unsupported columns
        delete _sqlMap.columns.REALTIME_BATTERY_SAVE;
        // delete _sqlMap.columns.REALTIME_ERROR;
        delete _sqlMap.columns.REALTIME_INTERNAL_ERROR;
        delete _sqlMap.columns.REALTIME_IS_ANONYMOUS;
        delete _sqlMap.columns.REALTIME_IS_BACKGROUND;
        delete _sqlMap.columns.REALTIME_IS_SMALL;
        // delete _sqlMap.columns.REALTIME_IS_SUCCESS;
        // delete _sqlMap.columns.REALTIME_FAILURE_RATE_DEFINITION;

        return _sqlMap;
    }

    static compileSQLStatements(
        supportedDatasourceColumns: IQueryContextDatasourceColumn[],
        queryContextSettings: IQueryContext['settings'],
        options: { gcpProjectId: GcpProjectId },
        customCompiledSqlTokens?: Partial<ICompiledSQLTokens>
    ) {
        return BiVizRealtimeCloudSaveGenericDatasource._compileSQLStatements(
            this.sqlMap,
            supportedDatasourceColumns,
            queryContextSettings,
            options,
            customCompiledSqlTokens
        );
    }
}

// incomplete_saves
export class BiVizRealtimeCloudSaveIncompleteSavesDatasource {
    static get sqlMap(): IDatasourceSQLMap {
        const _sqlMap = BiVizRealtimeCloudSaveGenericDatasource._sqlMap(
            'realtime_cloud_save_incomplete_saves'
        );

        // remove unsupported columns
        delete _sqlMap.columns.REALTIME_BATTERY_SAVE;
        // delete _sqlMap.columns.REALTIME_ERROR;
        delete _sqlMap.columns.REALTIME_INTERNAL_ERROR;
        delete _sqlMap.columns.REALTIME_IS_ANONYMOUS;
        delete _sqlMap.columns.REALTIME_IS_BACKGROUND;
        delete _sqlMap.columns.REALTIME_IS_SMALL;
        // delete _sqlMap.columns.REALTIME_IS_SUCCESS;
        // delete _sqlMap.columns.REALTIME_FAILURE_RATE_DEFINITION;

        return _sqlMap;
    }

    static compileSQLStatements(
        supportedDatasourceColumns: IQueryContextDatasourceColumn[],
        queryContextSettings: IQueryContext['settings'],
        options: { gcpProjectId: GcpProjectId },
        customCompiledSqlTokens?: Partial<ICompiledSQLTokens>
    ) {
        return BiVizRealtimeCloudSaveGenericDatasource._compileSQLStatements(
            this.sqlMap,
            supportedDatasourceColumns,
            queryContextSettings,
            options,
            customCompiledSqlTokens
        );
    }
}

// logins
export class BiVizRealtimeCloudSaveLoginsDatasource {
    static get sqlMap(): IDatasourceSQLMap {
        const _sqlMap = BiVizRealtimeCloudSaveGenericDatasource._sqlMap(
            'realtime_cloud_save_logins'
        );

        // remove unsupported columns
        delete _sqlMap.columns.REALTIME_BATTERY_SAVE;
        // delete _sqlMap.columns.REALTIME_ERROR;
        // delete _sqlMap.columns.REALTIME_INTERNAL_ERROR;
        // delete _sqlMap.columns.REALTIME_IS_ANONYMOUS;
        delete _sqlMap.columns.REALTIME_IS_BACKGROUND;
        delete _sqlMap.columns.REALTIME_IS_SMALL;
        // delete _sqlMap.columns.REALTIME_IS_SUCCESS;
        // delete _sqlMap.columns.REALTIME_FAILURE_RATE_DEFINITION;

        return _sqlMap;
    }

    static compileSQLStatements(
        supportedDatasourceColumns: IQueryContextDatasourceColumn[],
        queryContextSettings: IQueryContext['settings'],
        options: { gcpProjectId: GcpProjectId },
        customCompiledSqlTokens?: Partial<ICompiledSQLTokens>
    ) {
        return BiVizRealtimeCloudSaveGenericDatasource._compileSQLStatements(
            this.sqlMap,
            supportedDatasourceColumns,
            queryContextSettings,
            options,
            customCompiledSqlTokens
        );
    }
}
